import {CountriesSelectWithContainer} from "components/countries/select"
import {CountryState} from "models"
import React from "react"

export default {
  edit: {
    attributes: [
      {
        attribute: "countryId",
        content: ({inputProps}) => (
          <CountriesSelectWithContainer
            label={CountryState.humanAttributeName("country")}
            {...inputProps}
          />
        ),
        label: CountryState.humanAttributeName("country")
      },
      {attribute: "stateCode"},
      {attribute: "name", translated: true}
    ]
  },
  show: {
    attributesToShow: () => [
      "id",
      {attribute: "stateCode"},
      "name"
    ],
    relationships: ["country"],
    extraSelect: {
      CountryState: ["name"]
    }
  }
}
